import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class FileService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Delete files on main branch
     * Delete files, commit to main branch and push.
     *
     * @returns any OK.
     * @throws ApiError
     */
    deleteContent({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/files', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get branch files list
     * @returns any Ok.
     * @throws ApiError
     */
    getBranchFilesList({ orgId, projectId, branchName, cookie, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/files', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
            }, headers: {
                'cookie': cookie,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get file content
     * @returns binary File content.
     * @throws ApiError
     */
    getFileContent({ orgId, projectId, branchName, filePath, cookie, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/files/{filePath}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
                'filePath': filePath,
            }, headers: {
                'cookie': cookie,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get search results by files content.
     *
     * @returns SearchResult OK.
     * @throws ApiError
     */
    search({ orgId, projectId, branchName, filePath, searchText, matchCase, matchWord, useRegex, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/files/{filePath}/search', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
                'filePath': filePath,
            }, query: {
                'searchText': searchText,
                'matchCase': matchCase,
                'matchWord': matchWord,
                'useRegex': useRegex,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update files content by search pattern.
     *
     * @returns string OK.
     * @throws ApiError
     */
    replace({ orgId, projectId, branchName, filePath, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/files/{filePath}/replace', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
                'filePath': filePath,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Revert files in branch
     * Revert files in branch. If files are not specified, all files are being reverted.
     * @returns void
     * @throws ApiError
     */
    revertChanges({ orgId, projectId, branchName, commitHash, requestBody, cookie, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/commits/{commitHash}/revert', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
                'commitHash': commitHash,
            }, headers: {
                'cookie': cookie,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Upload binary files
     * @returns FileInfo Files content.
     * @throws ApiError
     */
    uploadBinaryFileContent({ orgId, projectId, branchName, commitHash, folderPath, formData, cookie, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/commits/{commitHash}/files', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
                'commitHash': commitHash,
            }, headers: {
                'cookie': cookie,
            }, query: {
                'folderPath': folderPath,
            }, formData: formData, mediaType: 'multipart/form-data', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get committed file content
     * @returns any OK.
     * @throws ApiError
     */
    getCommittedFileContent({ orgId, projectId, branchName, commitHash, filePath, cookie, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/commits/{commitHash}/files/{filePath}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
                'commitHash': commitHash,
                'filePath': filePath,
            }, headers: {
                'cookie': cookie,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update file content
     * @returns void
     * @throws ApiError
     */
    updateFileContent({ orgId, projectId, branchName, commitHash, filePath, requestBody, cookie, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/commits/{commitHash}/files/{filePath}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
                'commitHash': commitHash,
                'filePath': filePath,
            }, headers: {
                'cookie': cookie,
            }, body: requestBody, mediaType: 'application/json', errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get git-blame
     * @returns GitBlame OK.
     * @throws ApiError
     */
    getGitBlame({ orgId, projectId, branchName, commitHash, filePath, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/commits/{commitHash}/files/{filePath}/blame', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
                'commitHash': commitHash,
                'filePath': filePath,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=FileService.js.map